/* eslint-disable multiline-ternary */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Box, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from './styles';
import { getWellDetailsColumns } from '../../../hydraulics/featuredWellGrid/table_config';
import { updateRunGridDetails } from '../../../../store/actions/wells';
import { enqueueSnackbar } from '../../../../store/actions/snackbar';
import { HYDRAULICS_RUN_DETAILS, TOOLTIP_COLORS } from '../../../../utils/constants';
import { DirectionsRunOutlined, ShowChart } from '@mui/icons-material';
import RheologyChartModal from '../../../rheologyModal';

const RenderActions = ({
  row,
  expanded
}) => {
  const dispatch = useDispatch();
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [buttonTriggered, setButtonTriggered] = useState(false);

  useEffect(() => {
    setTooltipIsOpen(false);
    if (!buttonTriggered) {
      setTimeout(() => {
        setTooltipIsOpen(true);
      }, 1000);
    } else {
      setTooltipIsOpen(false);
    }
  }, [expanded]);

  const showError = (message) => {
    dispatch(enqueueSnackbar(message, 'error'));
    return false;
  };

  const validateRunDetails = (runDetails) => {
    const { bit_depth_offset, flow_in, hole_depth, sbp, rop } = runDetails;
    if (bit_depth_offset < -hole_depth || bit_depth_offset > 0) return showError(`Bit Off-Bottom Offset should be in the range from ${-hole_depth} to 0`);
    if (hole_depth < 0) return showError(HYDRAULICS_RUN_DETAILS.HOLE_DEPTH);
    if (rop < 0) return showError(HYDRAULICS_RUN_DETAILS.ROP);
    if (sbp < 0) return showError(HYDRAULICS_RUN_DETAILS.SBP);
    if (flow_in < 0) return showError(HYDRAULICS_RUN_DETAILS.FLOW_IN);
    return true;
  };

  const runHydraulicsSimulation = (row) => {
    if (validateRunDetails(row)) {
      setButtonTriggered(true);
      // dispatch(featuredWellRunHydraulics(featuredWellRun.wellsInfoId, {
      //   name: featuredWellRun?.runEntry?.name,
      //   runs: row
      // }));
    }
  };

  return (
    <Grid container justifyContent="center">
      <Tooltip
        title="Try Me!"
        arrow
        placement='right-end'
        open={tooltipIsOpen}
        onOpen={() => setTooltipIsOpen(false)}
        onClose={() => setTooltipIsOpen(false)}
        PopperProps={{ style: { zIndex: 0 } }}
        componentsProps={{
          tooltip: {
            sx: tooltipIsOpen && {
              '@keyframes tryme': {
                '0%': {
                  transform: 'scale(1)'
                },
                '5%': {
                  transform: 'scale(0.7)'
                },
                '10%': {
                  transform: 'scale(1.4)'
                },
                '20%': {
                  transform: 'scale(1.3)'
                },
                '30%': {
                  transform: 'scale(1)'
                },
              },
              animation: 'tryme 2.5s ease-in-out infinite',
              backgroundColor: TOOLTIP_COLORS.background,
              fontWeight: 'bold',
              color: TOOLTIP_COLORS.color,
              '& .MuiTooltip-arrow': {
                color: TOOLTIP_COLORS.background,
              },
            }
          }
        }}
      >
        <IconButton
          variant="solid"
          onClick={() => {
            runHydraulicsSimulation(row);
          }}
        >
          <DirectionsRunOutlined />
        </IconButton>
      </Tooltip>
    </Grid>
  );
};

const RunParametersInputField = ({ row, col, expanded }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(row[col.field]);

  const updateRunDetails = (e) => {
    setValue(e.target.value);
    dispatch(updateRunGridDetails(col.field, +e.target.value));
  };

  if (col.field === 'action') {
    return (
      <Grid sx={{
        flex: 0.5,
        p: 0,
        m: 0,
      }}>
        <RenderActions row={row} expanded={expanded} />
      </Grid>
    );
  }

  return (
    <TextField
      variant='filled'
      sx={{
        flex: 0.5,
        p: 0,
        m: 0,
        '.MuiInputBase-input': {
          padding: '10px',
          textAlign: 'center',
        }
      }}
      value={value}
      onChange={updateRunDetails}
    />
  );
};

function MobileFeaturedWellGrid({ data, gridKey, expanded, units }) {
  const classes = styles();
  const [showChart, setShowChart] = useState({
    data: null,
    open: false
  });

  const renderActions = ({
    row,
  }) => {
    return (
      <Grid container sx={{ flex: 0.5, justifyContent: 'center' }}>
        {<IconButton
          variant="solid"
          onClick={() => {
            setShowChart({
              data: [row],
              open: true
            });
          }}
        >
          <ShowChart />
        </IconButton>}
      </Grid>
    );
  };

  const columns = getWellDetailsColumns(gridKey, units, gridKey === 'drillFluids' ? renderActions : null);
  return (
    <>
      {data.map((row, index) => (
        <Box key={index} className={classes.gridContainer}>
          {columns.map((col) => {
            const value = col?.valueGetter ? col.valueGetter({ row }) : row[col.field];
            const isRunGrid = gridKey === 'runs';
            const isDrillFluidAction = gridKey === 'drillFluids' && col.field === 'action';

            return (
              <Grid container key={col.field} className={classes.gridItem}>
                <Typography
                  className={classes.headerName}
                  variant="body1"
                  sx={{ pt: isRunGrid && '5px' }}
                >
                  {col.headerName}
                </Typography>

                {isRunGrid ? (
                  <RunParametersInputField row={row} col={col} expanded={expanded} />
                ) : isDrillFluidAction ? (
                  renderActions?.({ row })
                ) : (
                  <Typography sx={{ flex: 0.5 }} variant="body1">
                    {value}
                  </Typography>
                )}
              </Grid>
            );
          })}
        </Box>
      ))}
      {
        showChart.open && <RheologyChartModal
          wellName={''}
          fluidName={''}
          isOpen={showChart.open}
          graphData={showChart?.data}
          onCloseClick={() => {
            setShowChart({
              data: null,
              open: false
            });
          }}
        />
      }
    </>
  );
}

export default MobileFeaturedWellGrid;
